const TAG_TYPE_STYLES = {
  N: {
    color: "var(--color-primary)",
    backgroundColor: "var(--color-pale-teal)"
  },
  T: {
    color: "var(--color-blue)",
    backgroundColor: "var(--color-blue-light)"
  },
  S: {
    color: "var(--color-orange)",
    backgroundColor: "var(--color-orange-light)"
  },
  F: {
    color: "var(--color-purple)",
    backgroundColor: "var(--color-purple-light)"
  }
};

export default TAG_TYPE_STYLES;
